<template>
  <div style="border: 1px solid #cccccc; border-radius: 5px" class="pa-2">
    <div>
      <v-layout>
        <v-flex> Total point: {{ totalPoint }} </v-flex>
        <v-flex class="text-xs-right">
          <v-btn @click="showCreateProject" outline>
            <em class="fa fa-plus mr-2" />เพิ่มโครงการ
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :loading="projectloading"
        :headers="headers"
        :items="data"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.project_name }}</td>
            <td>{{ props.item.floor }}</td>
            <td>{{ props.item.unit_no }}</td>
            <td>{{ props.item.area }}</td>
            <td>{{ props.item.point }}</td>
            <!-- <td>{{ props.item.group }}</td>
            <td>{{ props.item.lineid ? props.item.lineid : '-' }}</td> -->
            <td>
              <v-btn @click="deleteProject(props.item)" small icon>
                <v-icon small>delete</v-icon>
              </v-btn>
              <v-btn @click="showEditProject(props.item)" small icon>
                <v-icon small>edit</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showEdit" persistent width="550">
      <PersonalProjectEdit
        v-if="showEdit"
        :account_no="account_no"
        @close="showEdit = false"
        @oncreate="onCreateProject"
        @onedit="onEditProject"
        :edittype="edittype"
        :editdata="editdata"
      ></PersonalProjectEdit>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import PersonalProjectEdit from './PersonalProjectEdit.vue'
export default {
  props: ['account_no'],
  components: {
    PersonalProjectEdit
  },
  data() {
    return {
      projectloading: false,
      showEdit: false,
      edittype: '',
      editdata: '',
      data: [],
      headers: [
        {
          text: 'Project name',
          value: 'project_name'
        },
        { text: 'Floor', value: 'floor' },
        { text: 'Unit No.', value: 'unit_no' },
        { text: 'Area', value: 'area' },
        { text: 'Points', value: 'point' },
        // { text: 'Group', value: 'group' },
        // { text: 'Line ID', value: 'lineid' },
        { text: '', value: '' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    totalPoint() {
      if (this.data.length > 0) {
        return this.data
          .map((el) => {
            try {
              return parseInt(el.point)
            } catch (error) {
              return 0
            }
          })
          .reduce((prev, curr) => {
            return prev + curr
          }, 0)
      } else {
        return 0
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onCreateProject() {
      this.getData()
      this.showEdit = false
    },
    onEditProject() {
      this.getData()
      this.showEdit = false
    },
    showCreateProject() {
      this.edittype = 'create'
      this.editdata = ''
      this.showEdit = true
    },
    showEditProject(item) {
      this.edittype = 'edit'
      this.editdata = item
      this.showEdit = true
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,

        account_no: this.account_no
      }
      this.projectloading = true
      api.getmjdcustomerprojectdashboard(data, (err, response) => {
        this.projectloading = false
        if (response.responsecode == 200) {
          this.data = response.data2
        }
      })
    },
    async deleteProject(item) {
      console.log(item)
      var result = await this.$swal.fire({
        type: 'question',
        text: 'ต้องการลบใช่หรือไม่?',
        showCancelButton: true
        // reverseButtons: true,
      })
      var vm = this

      return new Promise((resolve, reject) => {
        if (result.value) {
          api.deletemjdcustomerprojectdashboard(
            { pageid: this.selectedBot.pageid, project_id: item.id },
            async (err, response) => {
              if (err) reject(err)
              if (response.responsecode == 200) {
                await this.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
                var index = vm.data.findIndex((el) => {
                  return item.id == el.id
                })
                if (index != -1) vm.data.splice(index, 1)
              }
              resolve()
            }
          )
        } else {
          resolve()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/PersonalProject.vue